<template>
    <div class="supply-currency-input">
        <vuex-currency-input
            :getter="() => params.value"
            :setter="value => setValue(value)"
            :disabled="isDisabled"
            :class="params.cellClass"
            :validations="validationRules"
            density="compact"
            variant="filled"
            :format="currencyFormat"
            is-validate-number
            :name="params.data.name"
        />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import isNumber from 'lodash/isNumber';

export default defineComponent({
    computed: {
        ...mapState('clientConfig', ['generalConfig']),

        isDisabled() {
            const data = this.params.data;
            return this.params.isDisabled(data) || this.params.context?.isReadOnly();
        },
        validationRules() {
            return this.params.getValidationRules(this.params);
        },
        currencyFormat() {
            const THREE_DP = 'numbers.default.currencyNoLabelPadded3dp';
            const TWO_DP = 'numbers.default.currencyNoLabelPadded';
            const raw = this.params?.value;
            const decimals = isNumber(raw) ? String(raw).split('.')[1]?.length : 0;

            if (decimals >= 3 || this.generalConfig?.displaySupplierPrices3dp) {
                return THREE_DP;
            }
            return TWO_DP;
        },
    },

    methods: {
        setValue(value) {
            const colId = this.params.column.colId;
            this.$nextTick(() => {
                this.params.node.setDataValue(colId, value);
            });
        },
    },
});
</script>

<style lang="scss">
.supply-currency-input {
    .v-field {
        border-radius: 0;

        .v-field__field {
            height: 100% !important;
            min-height: 0 !important;
        }

        .v-field__input {
            height: 100% !important;
            min-height: 0 !important;
        }
    }
}
</style>
